import React, { useEffect, useState } from 'react';
import { authApiService } from '../utils/authApiService';
import UserGrid from './admin/components/UserGrid';
import AddUserForm from './admin/components/AddUserForm';
import NavigationHeader from '../components/ui/NavigationHeader';

const AdminPage = ({ auth }) => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);

  const fetchUsers = async () => {
    setLoading(true);
    setError('');
    try {
      const users = await authApiService.getUsers();
      setUsers(users);
    } catch (err) {
      setError('Failed to load users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, []);

  const handleRoleChange = async (id, newRole) => {
    try {
      await authApiService.updateUserRole(id, newRole);
      fetchUsers();
    } catch {
      setError('Failed to update role');
    }
  };

  const handleAddUser = async (username, password, role) => {
    setAdding(true);
    setError('');
    try {
      await authApiService.register(username, password, role);
      await fetchUsers();
    } catch (err) {
      setError(err.message || 'Failed to add user');
      throw err;
    } finally {
      setAdding(false);
    }
  };

  if (!auth.user || auth.user.role !== 'admin') {
    return <div className="p-8 text-center">Not authorized</div>;
  }

  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader />
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground mb-2">
              Admin Panel
            </h1>
            <p className="text-muted-foreground">
              Manage users and roles for your solarium
            </p>
          </div>
          <AddUserForm onAddUser={handleAddUser} loading={adding} />
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl font-bold mb-6">User Management</h2>
            {error && <div className="text-red-500 mb-4">{error}</div>}
            {loading ? (
              <div>Loading users...</div>
            ) : (
              <UserGrid users={users} currentUserId={auth.user.id} onRoleChange={handleRoleChange} />
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminPage;
